<template>
    <div class="page">
        <div class="header">
            <div class="logo">
                <img src="../../../../assets/binance.png" width="36px" />
            </div>
            <div class="symbol">
                <div class="rate">
                    <el-tag :type="Math.abs(lastFundingRate) > 0.00099 ? 'warning' : 'success'" size="small">{{
                        lastFundingRate
                    }}</el-tag>
                </div>
                <div class="name">{{ currentusymbol.name }}</div>
            </div>
            <div class="marginType">
                <MarginType />
            </div>
            <div class="leverage">
                <Leverage />
            </div>
            <div class="risk">
                <el-input v-model="risk" style="width: 95px;">
                    <template #append>
                        <el-button @click="riskhandle">R</el-button>
                    </template>
                </el-input>
            </div>
            <div class="button">
                <el-button-group>
                    <el-button icon="Plus" @click="add()"></el-button>
                    <el-button icon="Refresh" @click="load()" :loading="loading"></el-button>
                    <el-button icon="Clock" @click="history()"></el-button>
                </el-button-group>
            </div>
        </div>
        <div class="table">
            <el-table :data="list" border empty-text="暂无配置">
                <el-table-column label="杠杆" width="80" align="center">
                    <template #default="{ row }">
                        <div :class="row.Status ? 'blue' : 'low'">
                            <el-input v-model="row.Lever" size="large" @change="change(row, 'lever')"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="本金" width="90" align="center">
                    <template #default="{ row }">
                        <span :class="row.Status ? 'high' : 'low'">{{ row.Amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="成交额" width="100" align="center">
                    <template #default="{ row }">
                        <span :class="row.Status ? 'high' : 'low'">{{ row.TransAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="止损" width="120" align="center">
                    <template #default="{ row }">
                        <div :class="row.Status ? 'red' : 'low'">
                            <el-input v-model="row.StopLoss" size="large" @input="input(row, 'StopLoss', 3)"
                                @change="change(row, 'stopLoss')">
                                <template #append>%</template>
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="止损金额" width="120" align="center">
                    <template #default="{ row }">
                        <div :class="row.Status ? 'red' : 'low'">
                            <el-input v-model="row.StopLossAmount" size="large" @input="input(row, 'StopLossAmount', 1)"
                                @change="change(row, 'stopLossAmount')">
                                <template #append>$</template>
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="止盈" width="120" align="center">
                    <template #default="{ row }">
                        <div :class="row.Status ? 'green' : 'low'">
                            <el-input v-model="row.TakeProfit" size="large" @input="input(row, 'TakeProfit', 3)"
                                @change="change(row, 'takeProfit')">
                                <template #append>%</template>
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="TakeProfitAmount" label="止盈金额" width="120" align="center">
                    <template #default="{ row }">
                        <div :class="row.Status ? 'green' : 'low'">
                            <el-input v-model="row.TakeProfitAmount" size="large"
                                @input="input(row, 'TakeProfitAmount', 1)" @change="change(row, 'takeProfitAmount')">
                                <template #append>$</template>
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="" :show-overflow-tooltip="true">
                    <template #default="{ row, $index }">
                        <el-button :icon="row.Status ? 'VideoPause' : 'VideoPlay'" size="large" @click="status(row)"
                            :disabled="statusloading"></el-button>
                        <el-button icon="Select" size="large" @click="save(row)" :disabled="saveloading"></el-button>
                        <el-button icon="Delete" size="large" @click="del(row, $index)"
                            :disabled="deleteloading"></el-button>
                        <el-button v-if="row.Status == 1" size="large" type="success" plain
                            @click="openPosition(row, 1)">多</el-button>
                        <el-button v-if="row.Status == 1" size="large" type="danger" plain
                            @click="openPosition(row, 2)">空</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <OpenPosition ref="OpenPositionRef" />
</template>
<style scoped>
.table>>>input {
    text-align: center !important;
    font-size: 16px;
    font-weight: bold;
}

.table>>>.el-button {
    padding: 12px 15px;
}

.table>>>.el-input__wrapper {
    background-color: #262727;
    box-shadow: none;
}

.table>>>.el-table--enable-row-hover .el-table__body tr:hover>td {
    background: #303133 !important;
}

.table>>>.el-input-group__append {
    box-shadow: none;
}

.page {
    padding: 10px 10px 0 10px !important;
}

.header {
    display: flex;
    height: 30px;
    margin-bottom: 20px;
}

.logo {
    padding-top: 5px;
    min-width: 60px;
    position: relative;
}

.symbol {
    min-width: 100px;
    position: relative;
    margin-right: 15px;
}

.symbol .name {
    font-size: 20px;
    line-height: 20px;
    font-weight: bold;
    color: #3da1d3;
}

.symbol .rate {
    position: absolute;
    left: 0;
    bottom: -15px;
    z-index: 100;
}

.marginType {
    width: 130px;
}

.leverage {
    margin-right: 10px;
}

.workingtype {
    margin-right: 10px;
}

.risk {
    margin-right: 10px;
    width: 105px;
}

.button {
    flex: 1;
    text-align: right;
}

.bold {
    font-size: 16px;
    font-weight: bold;
}

.table>>>.el-button--mini {
    padding: 7px 10px;
}

.table>>>.el-input-group__append {
    padding: 0 5px 0 0;
    font-size: 16px;
}

.high {
    font-weight: bold;
    font-size: 16px;
}

.low {
    font-weight: bold;
    color: #7c7c7c;
    font-size: 16px;
}

.low>>>.el-input__inner {
    color: #555555 !important;
}

.low>>>.el-input-group__append {
    color: #7c7c7c !important;
}

.red>>>.el-input__inner {
    color: #f56c6c !important;
}

.red>>>.el-input-group__append {
    color: #f56c6c !important;
}

.green>>>.el-input__inner {
    color: #67c23a !important;
}

.green>>>.el-input-group__append {
    color: #67c23a !important;
}

.blue>>>.el-input__inner {
    color: #e6a23c !important;
}
</style>
<script setup>
import { ref, toRaw, reactive, inject, onMounted } from 'vue'
import { ElNotification, ElMessage, ElMessageBox } from 'element-plus'
import * as binanceConstants from '@/utils/binanceConstants'
import Decimal from 'decimal.js'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import Database from '@/service/database'
import MarginType from "@/components/crypto/binance/entry/MarginType"
import Leverage from "@/components/crypto/binance/entry/Leverage"
import OpenPosition from "@/components/crypto/binance/positions/OpenPosition"
import { Helper } from '@/service'

const pannelActions = inject("pannelActions")
const systemStore = useSystemStore()
const logStore = useLogStore()
const loading = ref(false)
const saveloading = ref(false)
const deleteloading = ref(false)
const statusloading = ref(false)
const list = reactive([])
const currentusymbol = ref(systemStore.currentusymbol)
const OpenPositionRef = ref(null)
const lastFundingRate = ref(0)
const riskId = ref("")
const risk = ref(0)
const oldRisk = ref(0)

onMounted(async () => {
    load()
})

const load = async () => {
    try {
        loading.value = true

        //获取资金费率
        const rate = await systemStore.publicClient.fundingRate(currentusymbol.value.name)
        if (rate) lastFundingRate.value = parseFloat(rate.lastFundingRate)

        let _list = await Database.select('Entry', { index: 'Symbol', value: currentusymbol.value.name })
        list.splice(0, list.length, ..._list)
        loading.value = false

        //获取盈亏比设置
        let riskValue = await Database.selectAll('Risk')
        if (riskValue && riskValue.length > 0) {
            riskId.value = riskValue[0].Id
            risk.value = riskValue[0].RiskValue
            oldRisk.value = riskValue[0].RiskValue
        }
    } catch (error) {
        console.error('加载数据失败', error)
        loading.value = false
        logStore.addLog({
            title: '加载数据失败',
            level: 'error',
            message: error
        })
    }
}

const add = () => {
    let data = {
        Id: "",
        Symbol: currentusymbol.value.name,
        Lever: 0,
        Amount: 0,
        TransAmount: 0,
        StopLoss: 0,
        TakeProfit: 0,
        StopLossAmount: 0,
        TakeProfitAmount: 0,
        Status: 1
    }
    list.push(data)
}

const save = async (data) => {
    saveloading.value = true

    let _symbol = data.Symbol
    let _lever = data.Lever
    let _amount = parseFloat(data.Amount)
    let _transAmount = parseFloat(data.TransAmount)
    let _stopLoss = parseFloat(data.StopLoss)
    let _takeProfit = parseFloat(data.TakeProfit)
    let _stopLossAmount = parseFloat(data.StopLossAmount)
    let _takeProfitAmount = parseFloat(data.TakeProfitAmount)
    let _status = parseInt(data.Status)

    try {
        data.Id = data.Id || Helper.NewId()
        await Database.insert('Entry', {
            Id: data.Id,
            Symbol: _symbol,
            Lever: _lever,
            Amount: _amount,
            TransAmount: _transAmount,
            StopLoss: _stopLoss,
            TakeProfit: _takeProfit,
            StopLossAmount: _stopLossAmount,
            TakeProfitAmount: _takeProfitAmount,
            Status: _status
        })

        saveloading.value = false
        ElMessage.success('保存成功')
    } catch (error) {
        saveloading.value = false
        ElMessage.error('保存失败，系统异常')
        logStore.addLog({
            title: '保存配置失败',
            level: 'error',
            message: error
        })
    }
}

const change = (data, type) => {
    let lever = data.Lever
    let amount = data.Amount
    let transAmount = data.TransAmount
    let stopLoss = new Decimal(data.StopLoss || 0).dividedBy(100)
    let takeProfit = new Decimal(data.TakeProfit || 0).dividedBy(100)
    let stopLossAmount = data.StopLossAmount
    let takeProfitAmount = data.TakeProfitAmount

    //杠杆变化
    //只影响本金
    if (type === "lever") {
        if (lever <= 0) lever = 0
        if (lever == 0 || transAmount == 0) {
            amount = 0
            stopLossAmount = 0
            takeProfitAmount = 0
        } else {
            amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
        }
    }

    //止损变化
    //除杠杆外影响所有
    if (type === "stopLoss") {
        if (stopLoss <= 0) stopLoss = 0
        if (stopLoss == 0 || lever == 0) {
            transAmount = 0
            amount = 0
            stopLossAmount = 0
            takeProfitAmount = 0
        } else {
            transAmount = Number(new Decimal(stopLossAmount).dividedBy(stopLoss).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
            amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
            takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
        }
    }

    //止损金额变化
    if (type === "stopLossAmount") {
        if (stopLossAmount <= 0) stopLossAmount = 0
        if (stopLoss == 0 || lever == 0) {
            transAmount = 0
            amount = 0
            takeProfitAmount = 0
        } else {
            transAmount = Number(new Decimal(stopLossAmount).dividedBy(stopLoss).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
            amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
            takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
        }
    }

    //止盈变化
    //只影响止盈金额
    if (type === "takeProfit") {
        if (takeProfit <= 0) takeProfit = 0
        if (takeProfit == 0 || lever == 0) {
            takeProfitAmount = 0
        } else {
            takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_HALF_UP))
        }
    }

    //止盈金额变化
    //只影响止盈
    if (type === "takeProfitAmount") {
        if (takeProfitAmount <= 0) takeProfitAmount = 0
        if (transAmount == 0 || lever == 0) {
            takeProfit = 0
        } else {
            takeProfit = Number((new Decimal(takeProfitAmount).dividedBy(transAmount)).toDecimalPlaces(3, Decimal.ROUND_HALF_UP))
        }
    }
    data.Lever = lever
    data.Amount = amount
    data.TransAmount = transAmount
    data.StopLoss = Number(new Decimal(stopLoss).times(100))
    data.TakeProfit = Number(new Decimal(takeProfit).times(100))
    data.StopLossAmount = stopLossAmount
    data.TakeProfitAmount = takeProfitAmount
}

const del = (data, index) => {
    if (!data.Id) {
        list.splice(index, 1)
        return
    }

    ElMessageBox.confirm('你确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(async () => {
        deleteloading.value = true
        await Database.delete('Entry', data.Id)
        list.splice(index, 1)
        deleteloading.value = false
    }).catch((error) => {
        deleteloading.value = false
        if (error !== 'cancel') {
            ElMessage.error('删除失败，系统异常')
            logStore.addLog({
                title: '删除配置失败',
                level: 'error',
                message: error
            })
        }
    })
}

const input = (data, type, decimals) => {
    // 正则表达式：匹配整数或最多decimals位小数
    const regex = new RegExp(`^\\d*\\.?\\d{0,${decimals}}$`)
    if (!regex.test(data[type])) {
        // 如果输入的值不符合规则，则将其恢复为之前的值
        data[type] = data[type].slice(0, -1)
    }
}

const riskhandle = async () => {
    if (isNaN(risk.value)) {
        ElMessage.error('请输入数字')
        return
    }

    list.forEach(item => {
        if (item.Status == 0 || isNaN(item.StopLoss)) return
        item.TakeProfit = Number(new Decimal(item.StopLoss).times(risk.value).toDecimalPlaces(2, Decimal.ROUND_DOWN))

        if (item.TakeProfit < 0) item.TakeProfit = 0
        if (item.TakeProfit == 0 || item.lever == 0) {
            item.TakeProfitAmount = 0
        } else {
            item.TakeProfitAmount = Number(new Decimal(item.TransAmount).times(item.TakeProfit).dividedBy(100).toDecimalPlaces(2, Decimal.ROUND_DOWN))
        }
    })

    if (oldRisk.value == risk.value) {
        oldRisk.value = risk.value
        ElNotification({
            message: `止盈已重置`,
            type: 'info',
        })
        return
    }

    //保存盈亏比设置
    let _riskId = riskId.value || Helper.NewId()

    await Database.insert('Risk', {
        Id: _riskId,
        RiskValue: risk.value,
    })

    riskId.value = _riskId
    oldRisk.value = risk.value
    ElNotification({
        message: `R值已设置为${risk.value}`,
        type: 'info',
    })
}

const status = async (data) => {
    data.Status = Math.abs(data.Status - 1)
    statusloading.value = true
    try {
        await Database.insert('Entry', toRaw(data))
        statusloading.value = false
        ElMessage.success(data.Status ? '已启用' : '已禁用')
    } catch (error) {
        statusloading.value = false
        ElMessage.error('设置状态失败，系统异常')
        logStore.addLog({
            title: '设置状态失败',
            level: 'error',
            message: error
        })
    }
}

const openPosition = (data, type) => {
    data.positionSide = type === 1 ? binanceConstants.LONG : binanceConstants.SHORT
    let _leverage = currentusymbol.value.binanceConfig.leverage
    if (data.Lever != _leverage) {
        ElNotification.error({
            title: '杠杆与当前配置不一致',
        })
        return
    }

    //检查止损是否超过杠杆边界
    let stoploss = Number(new Decimal(data.StopLoss).dividedBy(100))
    let lever = Number(new Decimal(1).dividedBy(data.Lever))

    if (stoploss > lever) {
        ElNotification.error({
            title: '止损超过杠杆边界',
        })
        return
    }

    OpenPositionRef.value.init(data)
}

const history = () => {
    pannelActions.showHistory()
}

defineExpose({ load })

</script>